import { ActionIcon, Box } from "@mantine/core";
import { IconArrowBarDown, IconArrowBarToUp, IconRobotFace, IconUser } from "@tabler/icons-react";
import ActionButton from "../ActionButton";
import ChatMarkdown from "../ChatMarkdown";
import classes from "./SharedItem.module.css";
import type { ItemViewProps } from "./types";

export const ICON_SIZE = 32;

export function MessageItemView({
    item,
    opened,
    onOpen,
    onClose,
    actionButtons,
    containerClassName,
    showActions = true,
    containerRef,
}: ItemViewProps) {
    return (
        <Box className={`${classes.container} ${containerClassName ?? ""}`} ref={containerRef}>
            {showActions && (
                <ActionIcon.Group className={classes.icons}>
                    {item.context && (
                        <>
                            {!opened && (
                                <ActionButton
                                    onClick={onOpen}
                                    label="Show content"
                                    icon={<IconArrowBarDown stroke={1} />}
                                />
                            )}
                            {opened && (
                                <ActionButton
                                    onClick={onClose}
                                    label="Hide content"
                                    icon={<IconArrowBarToUp stroke={1} />}
                                />
                            )}
                        </>
                    )}
                    {actionButtons}
                </ActionIcon.Group>
            )}
            <Box>
                {(item.role ?? "ASSISTANT") === "USER" ? (
                    <IconUser size={ICON_SIZE} />
                ) : (
                    <IconRobotFace size={ICON_SIZE} />
                )}
            </Box>
            <Box className={classes.content}>
                {opened ? (
                    (item.role ?? "ASSISTANT") === "ASSISTANT" ? (
                        <ChatMarkdown content={item.content} />
                    ) : (
                        <Box className={classes.userInput}>{item.content}</Box>
                    )
                ) : (
                    <Box>CONTEXT</Box>
                )}
            </Box>
        </Box>
    );
}
